var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 48H36C38.2091 48 40 46.2091 40 44V11.2L28.8 0H4C1.79086 0 0 1.79086 0 4V44C0 46.2091 1.79086 48 4 48Z",
    fill: "#FF5000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 11.2L28.7998 0V7.2C28.7998 9.40914 30.5907 11.2 32.7998 11.2H39.9998Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50781 40.3998V32.2544H8.72145C9.33925 32.2544 9.86558 32.3724 10.3004 32.6084C10.7353 32.8417 11.0667 33.1665 11.2947 33.5828C11.5254 33.9964 11.6408 34.4737 11.6408 35.0146C11.6408 35.5555 11.5241 36.0328 11.2908 36.4464C11.0574 36.8601 10.7194 37.1822 10.2766 37.4129C9.83641 37.6436 9.30346 37.7589 8.6777 37.7589H6.6294V36.3788H8.39929C8.73073 36.3788 9.00384 36.3218 9.21861 36.2078C9.43603 36.0911 9.59777 35.9307 9.70384 35.7266C9.81255 35.5197 9.8669 35.2824 9.8669 35.0146C9.8669 34.7442 9.81255 34.5082 9.70384 34.3067C9.59777 34.1025 9.43603 33.9447 9.21861 33.8334C9.00118 33.7194 8.72543 33.6623 8.39134 33.6623H7.22997V40.3998H5.50781Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6469 40.3998H12.7594V32.2544H15.6707C16.4901 32.2544 17.1954 32.4175 17.7866 32.7436C18.3779 33.0671 18.8327 33.5324 19.1509 34.1396C19.4717 34.7468 19.6321 35.4733 19.6321 36.3192C19.6321 37.1677 19.4717 37.8968 19.1509 38.5067C18.8327 39.1165 18.3753 39.5845 17.7787 39.9106C17.1848 40.2368 16.4741 40.3998 15.6469 40.3998ZM14.4815 38.9243H15.5753C16.0844 38.9243 16.5126 38.8341 16.8599 38.6538C17.2099 38.4709 17.4724 38.1885 17.6474 37.8067C17.8251 37.4222 17.9139 36.9264 17.9139 36.3192C17.9139 35.7173 17.8251 35.2254 17.6474 34.8436C17.4724 34.4618 17.2113 34.1807 16.8639 34.0004C16.5166 33.8201 16.0884 33.73 15.5793 33.73H14.4815V38.9243Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9078 40.3998V32.2544H26.301V33.6743H22.63V35.6152H25.943V37.0351H22.63V40.3998H20.9078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.182e63085002df5893556b9bc14f1bb4.svg";
export { ForwardRef as ReactComponent };